import { gql } from '@apollo/client';

export const GET_ORG_PAGE_QUERY = gql`
  query getOrgPage($cursor: String, $limit: Int) {
    me {
      organizationPage(cursor: $cursor, limit: $limit) {
        organizations {
          id
          name
        }
        cursor
      }
    }
  }
`;
